import React, { useState } from 'react';
import * as Constants from '../../constants';
import { db, cloudFunctions } from '../../config/Fire';
import { Result, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import LoadingPage from '../components/LoadingPage';
import PL01 from '../admin/Surveys/templates/PL01';
import PL02 from '../admin/Surveys/templates/PL02';
import PL03 from '../admin/Surveys/templates/PL03';
import './styles.css';

const SurveyAssigned = (props) => {
    const[error, setError] = useState(false)
    const[surveyAssigned, setSurveyAssigned] = useState(null)
    const[userAssigned, setUserAssigned] = useState(null)
    const[solvingSurvey, setSolvingSurvey] = useState(false)
    const[surveySolved, setSurveySolved] = useState(false)

    const getSurvey = pathname => {
        const pathnameSplited = pathname.split("/")
        if(pathnameSplited.length === 3) {
            const id = pathnameSplited[2]
            db.ref(`${Constants.MAIN_NODES.SURVEYS_ASSIGNED}/${id}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists()) {
                    const survey = snapshot.val();
                    db.ref(`${Constants.MAIN_NODES.USERS}/${survey.userId}`).once("value")
                    .then((userSnapshot) => {
                        if(userSnapshot.exists()) {
                            const user = userSnapshot.val();
                            setSurveyAssigned(survey)
                            setUserAssigned(user)
                        } else {
                            console.log("Error getting documents");
                            setError(true)        
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        setError(true)
                    });
                } else {
                    console.log("Error getting documents");
                    setError(true)
                }
            })
            .catch(err => {
                console.log(err);
                setError(true)
            });
        } else {
            console.log("Error getting documents");
            setError(true)
        }
        return <LoadingPage />
    }

    const sendPL = values => {
        setSolvingSurvey(true)
        cloudFunctions.tryResolveSurvey({
            userId: userAssigned.id,
            userEmail: userAssigned.email,
            surveyType: surveyAssigned.surveyType,
            surveyName: surveyAssigned.surveyName,
            answers: values,
            assignedDate: surveyAssigned.assignedDate,
            assignedDateLong: surveyAssigned.assignedDateLong,
            surveyAssignedId: surveyAssigned.id,
            userToken: userAssigned.token,
        })
        .then(result => {
            setSolvingSurvey(false)
            if(result && result.data && result.data.code === 0) {
                setSurveySolved(true)
                message.success("La encuesta se resolvió exitósamente")
            } else {
                setSurveySolved(false)
                console.log(result)
                message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
            }
        })
        .catch((err) => {
            setSolvingSurvey(false)
            setSurveySolved(false)
            console.log(err)
            message.error("Se produjo un error. Por favor, vuelva a intentarlo.")
        })
    }

    const getSurveyType = (surveyAssigned, userAssigned) => {
        switch (Constants.SurveysTypes[surveyAssigned.surveyType]) {
            case Constants.SurveysTypes.PL01:
                return <PL01 surveyAssigned={surveyAssigned} userAssigned={userAssigned} onSubmit={sendPL} />
            case Constants.SurveysTypes.PL02:
                return <PL02 surveyAssigned={surveyAssigned} userAssigned={userAssigned} onSubmit={sendPL} />
            case Constants.SurveysTypes.PL03:
                return <PL03 surveyAssigned={surveyAssigned} userAssigned={userAssigned} onSubmit={sendPL} />
            default:
                setError(true)
                break;
        }
    }

    return (
        <div className="SurveyAssignedCont">
            {
                error ?
                    <Result
                    className="resultCont"
                    status="404"
                    title="404"
                    subTitle="Lo siento, no se encontro la encuesta solicitada."/>
                    :
                    solvingSurvey ?
                        <Result
                            className="resultCont"
                            icon={<LoadingOutlined />}
                            title="Resolviendo la encuesta..."
                            subTitle="Aguarde un instante"/>
                        :
                        surveySolved ?
                            <Result
                                className="resultCont"
                                status="success"
                                title="¡La encuesta se resolvió exitósamente!"
                                subTitle="Agradecemos su colaboración"/>
                            :
                            (surveyAssigned && userAssigned) ?
                                getSurveyType(surveyAssigned, userAssigned)
                                :
                                getSurvey(props.props.location.pathname)
            }
        </div>
    );
};

SurveyAssigned.propTypes = {
    
};

export default SurveyAssigned;